import React from 'react';
import { createIcon } from '@stockx/icons';

const TwitterIcon = createIcon({
  displayName: 'TwitterIcon',
  viewBox: '0 0 44 44',
  path: (
    <g>
      <path d="M39.44,14.24c.03,.39,.03,.77,.03,1.16,0,11.89-9.05,25.61-25.61,25.61h0c-4.89,0-9.68-1.4-13.8-4.04,.71,.09,1.43,.13,2.14,.13,4.05,0,7.99-1.36,11.18-3.86-3.85-.07-7.23-2.58-8.41-6.25,1.35,.26,2.74,.21,4.06-.16-4.2-.85-7.22-4.54-7.22-8.82v-.11c1.25,.7,2.65,1.08,4.08,1.13C1.95,16.38,.73,11.12,3.12,7.01c4.57,5.62,11.31,9.04,18.55,9.4-.73-3.13,.27-6.4,2.6-8.6,3.62-3.41,9.33-3.23,12.73,.39,2.02-.4,3.95-1.14,5.72-2.18-.67,2.08-2.08,3.85-3.96,4.98,1.78-.21,3.53-.69,5.17-1.42-1.21,1.81-2.73,3.39-4.49,4.66Z" />
    </g>
  ),
});

export default TwitterIcon;
